import clsx from "clsx";

const COLOR_CLASSES = {
  success: "bg-success-bg text-success-hover dark:bg-success-bgOnDark dark:text-success-onDark",
  danger: "bg-danger-bg text-danger-hover dark:bg-danger-bgOnDark dark:text-danger-onDark",
  warning: "bg-warning-bg text-warning dark:bg-warning-bgOnDark dark:text-warning-onDark",
  info: "bg-info-bg text-info dark:bg-info-bgOnDark dark:text-info-onDark",
  purple: "bg-purple-100 text-purple-700 dark:bg-purple-950 dark:text-purple-300",
  emerald: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  gray: "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300",
};

// Matches DESIGN.md's Badges spec: pill radius, tint background + saturated text,
// static (no interactive states). Callers own their own status/type -> color
// mapping (e.g. STATUS_COLORS, TYPE_COLORS) and just pass the resolved color name —
// this component only unifies the rendering, not the business vocabulary.
export default function Badge({ color = "gray", className, children }) {
  return (
    <span
      className={clsx(
        "inline-flex items-center rounded-pill px-2.5 py-0.5 text-xs font-medium",
        COLOR_CLASSES[color] ?? COLOR_CLASSES.gray,
        className
      )}
    >
      {children}
    </span>
  );
}
